// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import X from "@insite/mobius/Icons/X";
import { myListsDetailsOptionsStyles } from "@steiner/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import Cart from "@steiner/XDL/Icons/Cart";
import { color, createLinkIconStyles } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        margin-bottom: 16px;

        @media print {
            display: none;
        }
    `,
};

myListsDetailsOptionsStyles.leftColumnWrapper = {
    css: css`
        width: 100%;
    `,
};

myListsDetailsOptionsStyles.container = {
    gap: 20,
};

myListsDetailsOptionsStyles.sortOrderGridItem = { width: 12 };

myListsDetailsOptionsStyles.searchGridItem = {
    width: [12, 12, 6, 3, 3],
    css: css`
        position: relative;

        &&& input {
            padding-right: 55px;
        }
    `,
};

// myListsDetailsOptionsStyles.search = searchfieldInputStyle;

myListsDetailsOptionsStyles.sortByGridItem = {
    width: [12, 12, 6, 3, 3],
};

myListsDetailsOptionsStyles.sortBySelect = {
    cssOverrides: {
        formField: css`
            label {
                width: auto;
            }
        `,
        formInputWrapper: css`
            flex: 1;
        `,
    },
};

myListsDetailsOptionsStyles.selectAllGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        align-items: center;
    `,
};

myListsDetailsOptionsStyles.selectAllWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        column-gap: 32px;
        row-gap: 20px;
    `,
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
    `,
};

myListsDetailsOptionsStyles.addSelectedToCartLink = {
    ...createLinkIconStyles({
        icon: Cart,
        linkStyles: {
            icon: {
                position: "left",
            },
            css: css`
                display: flex;
                justify-content: center;
                &:disabled {
                    opacity: 0.33;
                }
            `,
        },
    }),
};

myListsDetailsOptionsStyles.deleteSelectedLink = {
    ...createLinkIconStyles({
        icon: X,
        linkStyles: {
            icon: {
                position: "left",
            },
        },
    }),
};

myListsDetailsOptionsStyles.editSortOrderLink = {
    ...createLinkIconStyles({
        icon: ChevronsUpDown,
        linkStyles: {
            icon: {
                position: "left",
            },
        },
    }),
};

myListsDetailsOptionsStyles.deleteListItemsModal = {
    submitButton: {
        color: "primary",
    },
};

myListsDetailsOptionsStyles.clearIcon = {
    size: 16,
    color: "common.ui1",
    css: css`
        top: 20px;
        right: 42px;
        border-radius: 50%;
        background: ${color("primary")};
        padding: 2px;
        cursor: pointer;
        position: absolute;
    `,
};